<template>
  <div class="broadcast-item" :class="{ 'actice': Boolean(activeId && [row.id, row.uuid].includes(activeId)) }"
    ref="broadcastItem">
    <slot name="header">
    </slot>
    <slot name="body">
      <el-input v-model="row.content" type="textarea" resize="none"
        placeholder="请输入您的播报文案，描述事件要点、亮点或传达的核心信息。请保持语言生动、简洁明了，以便听众快速抓住重点。(注意:文案内容不得少于4个数)"
        class="broadcast-input"></el-input>
    </slot>
    <slot name="footer">
      <div class="footer-option">
        <el-button v-if="false" type="primary" class="assistant-button" @click="emits('footerOptionFn', 'assistant')">
          <span v-if="showPromptContent" class="prompt-content">没有文案？文案助理来帮忙</span>
          <svgIcon iconClass="jiqiren" width="1.5vw" height="1.5vw" />
        </el-button>
        <el-button type="danger" v-if="deleteBtn" :icon="Delete" circle @click="emits('footerOptionFn', 'delete')" />
      </div>
    </slot>

  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue';
import { Delete, SuccessFilled } from '@element-plus/icons-vue'
let emits = defineEmits('footerOptionFn')
const props = defineProps({
  deleteBtn: {
    type: Boolean,
    default: true
  },
  row: {
    type: Object,
    default: () => ({})
  },
  activeId: {
    type: String,
    default: ''
  }
});
const broadcastItem = ref(null);
const showPromptContent = ref(true);
let resizeObserver

const handleResize = () => {
  if (broadcastItem.value) {
    showPromptContent.value = (broadcastItem.value.clientWidth >= 500);
  }
};

onMounted(() => {
  resizeObserver = new ResizeObserver(handleResize);
  if (broadcastItem.value) {
    resizeObserver.observe(broadcastItem.value);
  }
  nextTick(() => handleResize());
});

onBeforeUnmount(() => {
  if (resizeObserver && broadcastItem.value) {
    resizeObserver.unobserve(broadcastItem.value);
  }
});

</script>

<style scoped lang="scss">
.broadcast-item {
  width: 100%;
  min-height: 250px;
  background: linear-gradient(135deg, #2a2a2a, #444444);
  padding: 20px;
  border: 1px solid #555555;
  text-align: center;
  color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-sizing: border-box;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  &.actice {
    border: 3px solid #409eff;

  }
}

.broadcast-input {
  flex: 1;
  width: 100%;
  margin-bottom: 10px;
  resize: none;

  :deep(.el-textarea__inner) {
    height: 100%;
    background-color: #333333;
    color: white;
    border-radius: 4px;
  }
}

.footer-option {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;

  .el-button.assistant-button {
    background-color: #409EFF;
    border-color: #409EFF;
    color: white;
    font-size: 12px;
    padding: 8px 16px;
    box-sizing: border-box;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 5px;

    &:hover {
      background-color: #66b1ff;
      border-color: #66b1ff;
    }
  }
}
</style>
